import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSortAscending = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.3064 4.56514C12.2129 4.52328 12.1091 4.5 12 4.5C11.8952 4.5 11.7955 4.52145 11.7049 4.56021C11.6198 4.59651 11.5401 4.64925 11.4705 4.7184L11.4689 4.72001L6.21999 9.9689C5.92667 10.2622 5.92667 10.7378 6.21999 11.0311C6.51332 11.3244 6.98889 11.3244 7.28222 11.0311L11.2489 7.06444V18.9978C11.2489 19.4126 11.5852 19.7489 12 19.7489C12.4148 19.7489 12.7511 19.4126 12.7511 18.9978V7.06446L16.7178 11.0311C17.0111 11.3245 17.4867 11.3245 17.78 11.0311C18.0733 10.7378 18.0733 10.2622 17.78 9.9689L12.5311 4.72001C12.5199 4.70881 12.5084 4.69803 12.4967 4.68769L12.3064 4.56514Z",
		fill: "currentColor"
	})
});
export { SvgIconSortAscending as ReactComponent };
